import { useEffect, useState } from "react";

import MyProfileStore from "../../modules/MyProfile/store";
import { UserInfoDto } from "../../modules/MyProfile/types";
import { MessageResultState } from "../../types/general-types";
import { getActiveSessionKey } from "../../utils/SsoSession";

/**
 * Header ve avatar menüsü aynı profili kullandığı için sonuç aktif oturum
 * anahtarına göre önbelleklenir; sayfa başına tek istek atılır.
 */
let cache: { sessionKey: string | null; promise: Promise<UserInfoDto | null> } | null = null;
let resolved: { sessionKey: string | null; user: UserInfoDto } | null = null;

function readResolved(): UserInfoDto | null {
  return resolved && resolved.sessionKey === getActiveSessionKey() ? resolved.user : null;
}

function loadCurrentUser(): Promise<UserInfoDto | null> {
  const sessionKey = getActiveSessionKey();
  if (cache && cache.sessionKey === sessionKey) return cache.promise;

  const promise = new MyProfileStore()
    .getUserInfos()
    .then((response) =>
      response?.state === MessageResultState.SUCCESS ? response.result : null
    )
    // Hata toast'ı axios interceptor'ından geliyor; burada baş harf fallback'i kalır.
    .catch(() => null)
    .then((result) => {
      // Başarısızlık önbelleğe alınmaz: geçici bir ağ hatası avatarı kalıcı boş bırakırdı.
      if (result === null && cache?.promise === promise) cache = null;
      if (result !== null) resolved = { sessionKey, user: result };
      return result;
    });

  cache = { sessionKey, promise };
  return promise;
}

export function useCurrentUser(): UserInfoDto | null {
  const [user, setUser] = useState<UserInfoDto | null>(readResolved);

  useEffect(() => {
    let isMounted = true;
    loadCurrentUser().then((result) => {
      if (isMounted) setUser(result);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  return user;
}
